import styled from "styled-components";
import { CircularProgress } from "@mui/material"

export const Ul = styled.ul`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 60%;
    margin-bottom: 20px;
    margin-top: 40px;
    position: relative;
    right: -100px;

    @media (max-width: 1250px){
        width: 55%;
    }

    @media (max-width: 1024px){
        width: 90%;
        margin-top: 0;
        right: 0;
    }
`
export const Loading = styled(CircularProgress)`
    margin-top: 50px;
   svg{
        color: var(--secundary-color);
    }
`